import { Injectable } from '@angular/core';

export interface Toast {
  header: string;
	body: string;
	classname?: string;
	delay?: number;
  autoClose?: boolean;
  action?: { label: string; callback: () => void; };
  id?: string;
}

export interface ToastTrack extends Toast {
  id: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
	toasts: ToastTrack[] = [];

	show(toast: Toast) : ToastTrack {
    let toastTrack : ToastTrack = {
      body : toast.body,
      header: toast.header,
      id : toast.id ?? this.generateGUID(),
      classname : toast.classname,
      delay : toast.delay,
      autoClose: toast.autoClose !== undefined ? toast.autoClose : true
    };
		this.toasts.push(toastTrack);
    return toastTrack;
	}

	remove(toastId: string) {
		this.toasts = this.toasts.filter((t) => t.id !== toastId);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}


  generateGUID(): string {
    const buf = new Uint8Array(16);
    window.crypto.getRandomValues(buf);
    // Properly format the GUID using hexadecimal values
    return (
      this.hex(buf[0]) + this.hex(buf[1]) +
      this.hex(buf[2]) + this.hex(buf[3]) + '-' +
      this.hex(buf[4]) + this.hex(buf[5]) + '-' +
      '4' + this.hex(buf[6]).substring(1, 4) + '-' + // The 4 indicates the UUID version, changed substr to substring
      ((buf[8] & 0x3f) | 0x80).toString(16) + this.hex(buf[7]) + '-' +
      this.hex(buf[8]) + this.hex(buf[9]) +
      this.hex(buf[10]) + this.hex(buf[11]) +
      this.hex(buf[12]) + this.hex(buf[13]) +
      this.hex(buf[14]) + this.hex(buf[15])
    ).toLowerCase(); // Lowercase is conventional for GUIDs
  }

  // Helper function to convert a byte into a 2-character hexadecimal string
  private hex(byte: number): string {
    return ('0' + byte.toString(16)).slice(-2);
  }
}
